import customSelect from 'custom-select';
import Plyr from 'plyr';
//require('../../node_modules/plyr/dist/plyr.css');
import 'plyr/dist/plyr.css';

document.addEventListener('DOMContentLoaded',function() {

    const el = document.getElementById('videolist');

    const init = function() {

        const item = el.querySelectorAll("[data-value]"),
              firstItem = el.getElementsByTagName('li')[0],
              // Universal video reference: { id, provider }. `provider`
              // defaults to 'vimeo' so any markup that doesn't (yet) declare
              // data-provider keeps working exactly as before.
              firstVideo = {
                  id: firstItem.dataset.value,
                  provider: firstItem.dataset.provider || 'vimeo',
              },
              select = el.getElementsByTagName('select');

        let mobile, player;

        // Per-provider Plyr embed settings. Only the block matching the
        // currently active source.provider is ever consulted by Plyr, so
        // both can be declared once and shared between desktop/mobile
        // player instances without duplicating provider-specific config.
        const providerOptions = {
            vimeo: {
                sidedock: 0,
                controls: 0,
            },
            youtube: {
                rel: 0,
                modestbranding: 1,
            },
        };

        const initSelect = function() {
    
            const cstSel = customSelect(select);
            
            for (let i = 0; i < select.length; i ++) {
                cstSel[i].container.addEventListener('custom-select:open', (e) => { 
                    e.target.style.position = 'relative';
                    e.target.style.zIndex = '5';
                });
                
                cstSel[i].container.addEventListener('custom-select:close', (e) => { 
                    e.target.removeAttribute('style');
                });
                
                cstSel[i].select.addEventListener('change', (e) => { 
                    if (e.target.classList.contains('c-videolist__select')) {
                        const option = e.target.selectedOptions[0];
                        window.videolist.play(e.target.value, option && option.dataset.provider);
                    }
                });
            }
        };

        window.videolist = {
            def: function() {
                videolist.play(firstVideo.id, firstVideo.provider);
            },
            destroy: function() {
                if (player != undefined) {
                    player.destroy();
                }
            },
            load: function(e) {
                const { value, provider } = e.currentTarget.dataset;
                videolist.play(value, provider);
            },
            // provider defaults to 'vimeo' to stay backward compatible with
            // any caller still passing just an id.
            play: function(id, provider = 'vimeo') {
                player.source = {
                    type: 'video',
                    sources: [
                        {
                            src: id,
                            provider,
                        },
                    ],
                };
            },
            player_desktop: function() {
                player = new Plyr('#player', {
                    ratio: '16:9',
                    ...providerOptions,
                });
                videolist.def();
            },
            player_mobile: function() {
                player = new Plyr('#player', {
                    ...providerOptions,
                });
                videolist.def();
            }
        }

        for (let i = 0; i < item.length; i++) {
            item[i].addEventListener('click', videolist.load);
        }
        
        const responsive = function() {
            if (window.innerWidth > 768) {
                if (!mobile) {
                    if (player === undefined) {
                        videolist.player_desktop();
                    }
                } else {
                    if (mobile === true) {
                        videolist.destroy();
                        
                        setTimeout(function() {
                            videolist.player_desktop();
                        }, 1000);
                        mobile = false;
                    }
                }

            } else {
                if (!mobile) {
                    if (player === undefined) {
                        // First run on a mobile viewport: create the player
                        // immediately, same as the desktop first-run path.
                        // Delaying this via setTimeout left `player`
                        // undefined for ~1s after load, so selecting a
                        // video from the <select> in that window called
                        // `player.source = ...` on an undefined player and
                        // silently failed.
                        videolist.player_mobile();
                    } else {
                        videolist.destroy();

                        setTimeout(function() {
                            videolist.player_mobile();
                        }, 1000);
                    }
                    mobile = true;
                }
            }           
        }
        
        select ? initSelect() : false;

        responsive();
        window.addEventListener('resize', responsive);
    };
    
    el ? init() : false; 

}, false)
